import { A } from './a.tsx'
import { Blockquote } from './blockquote.tsx'
import { Code } from './code.tsx'
import { H1 } from './h1.tsx'
import { H2 } from './h2.tsx'
import { H3 } from './h3.tsx'
import { H4 } from './h4.tsx'
import { Large } from './large.tsx'
import { Lead } from './lead.tsx'
import { Muted } from './muted.tsx'
import { P } from './p.tsx'
import { Small } from './small.tsx'
import { Td, Th, Tr } from './table.tsx'
import { Ul } from './ul.tsx'

export const T = {
	a: A,
	blockquote: Blockquote,
	code: Code,
	h1: H1,
	h2: H2,
	h3: H3,
	h4: H4,
	large: Large,
	lead: Lead,
	muted: Muted,
	p: P,
	small: Small,
	td: Td,
	th: Th,
	tr: Tr,
	ul: Ul,
}
